import { Switch } from "@blueprintjs/core"
import { UseControllerProps, useController } from "react-hook-form"
import { WaveInputs } from "../types/form"

import { inputCss } from "../OrdersTable.styled"
import { ToggleInputContainer } from "./ToggleInput.styled"
import { ErrorIconWithTooltip } from "../../../../components/ErrorIconWithTooltip"

interface IToggleInputProps extends UseControllerProps<WaveInputs> {
  index: number
  label?: string
  disabled?: boolean
}

export const ToggleInput = ({
  index,
  control,
  name,
  label,
  disabled = false,
  rules,
}: IToggleInputProps) => {
  const { field, fieldState } = useController({ control, name, rules })

  return (
    <ToggleInputContainer>
      <Switch
        checked={field.value}
        onChange={field.onChange}
        label={label}
        disabled={disabled}
        innerLabelChecked="Yes"
        innerLabel="No"
        css={inputCss(index)}
      />
      {fieldState.error && <ErrorIconWithTooltip errorMessage={fieldState.error.message} />}
    </ToggleInputContainer>
  )
}
